const toLocalISODateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const parseDateString = (input) => {
  if (!input) return null;

  if (input instanceof Date) {
    return isNaN(input.getTime()) ? null : input;
  }

  const dateString = String(input);
  let date;

  // Case 1: ISO format
  if (dateString.includes("T") || dateString.includes("-")) {
    const isoDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/;
    const match = dateString.match(isoDateOnly);

    if (match) {
      const [, y, m, d] = match;
      date = new Date(Number(y), Number(m) - 1, Number(d));
    } else {
      date = new Date(dateString);
    }
  }
  // Case 2: DD/MM/YY or DD/MM/YYYY
  else if (dateString.includes("/")) {
    const [day, month, yearRaw] = dateString.split("/");

    let year = yearRaw;

    // convert 2-digit year → 20YY
    if (year.length === 2) {
      year = "20" + year;
    }

    date = new Date(Number(year), Number(month) - 1, Number(day));
  }

  if (!date || isNaN(date.getTime())) {
    return null;
  }

  return date;
};

export const formatDateDDMMYYYY = (dateString) => {
  if (!dateString) return "";

  const date = parseDateString(dateString);

  if (!date) {
    console.warn("Invalid date:", dateString);
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const isAuthenticated = () => {
  return !!localStorage.getItem("authToken");
};

export const formatBudget = (value) => {
  if (!value) return "";

  if (value >= 10000000) {
    return (value / 10000000).toFixed(1).replace(/\.0$/, "") + " Cr";
  }

  if (value >= 100000) {
    return (value / 100000).toFixed(1).replace(/\.0$/, "") + " L";
  }

  if (value >= 1000) {
    return (value / 1000).toFixed(1).replace(/\.0$/, "") + " K";
  }

  return value.toString();
};

export const splitBudgetIntoValueAndUnit = (value) => {
  if (!value && value !== 0) return { value: "", unit: "" };

  const formatted = formatBudget(value); // e.g. "13 L"

  const [num, unit] = formatted.split(" ");

  return {
    value: Number(num),
    unit: unit || "",
  };
};



export const convertBudgetToNumber = (value, unit) => {
  if (value === null || value === undefined || value === "") return "";

  if (!unit && typeof value === "string") {
    const match = value.trim().toLowerCase().match(/^(\d+(\.\d+)?)\s?(k|l|cr)?$/);
    if (!match) return "";
    value = match[1];
    unit = match[3];
  }

  const num = Number(value);
  if (isNaN(num)) return "";

  switch ((unit || "").toLowerCase()) {
    case "cr":
      return Math.round(num * 1_00_00_000);
    case "l":
      return Math.round(num * 1_00_000);
    case "k":
      return Math.round(num * 1_000);
    default:
      return Math.round(num);
  }
};




export const formatINR = (value) => {
if (value === null || value === undefined || value === "") return "—";
const num = Number(value);
if (Number.isNaN(num)) return `₹${String(value)}`;
return `₹${num.toLocaleString("en-IN")}`;
};


export const priceRangeLabel = (min_budget, max_budget, price_range) => { 
  return min_budget !== undefined && max_budget !== undefined
    ? `${formatINR(min_budget)} - ${formatINR(max_budget)}`
    : price_range || "—";
};

export const formatTimeline = (value) => {
  if (!value) return "-";

  return value
    .replace(/_/g, " ")                 // 1_month → 1 month
    .replace(/\b\w/g, (c) => c.toUpperCase()); // → 1 Month
};



export const formatDateAPIFormat = (date) => {
  if (!date) return "";

  let d;

  // If already Date object
  if (date instanceof Date) {
    d = date;
  }

  // DD/MM/YYYY or DD-MM-YYYY or DD-MM-YY
  else if (typeof date === "string") {
    const normalized = date.replace(/-/g, "/"); // unify separator
    const parts = normalized.split("/");

    if (parts.length === 3) {
      let [day, month, year] = parts;

      // handle 2-digit year
      if (year.length === 2) {
        year = "20" + year;
      }

      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }

    d = new Date(date);
  }

  else {
    d = new Date(date);
  }

  if (isNaN(d.getTime())) return "";

  return toLocalISODateString(d);
};


export function formatDateTime(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

  // helper to normalize values
  export const normalize = (val) => (val || "").toString().trim().toLowerCase();